// @ts-expect-error
import React, { useState } from "react";

import classnames from "classnames";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Collapse } from "Cobalt/Collapse";
import BodyText from "Common/BodyText";
import { Card, CardSection } from "Common/Card/";
import { Div } from "Common/HTML";
import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

const bem = makeBem("ExpandingFAQs");
const ANALYTICS_LOCATION = "compact_quote_page";

type FAQCardProps = {
  question: string;
  answer: string;
  updateNumOpen?: (arg0: number) => void;
};

export const FAQCard = ({ question, answer, updateNumOpen }: FAQCardProps) => {
  const [isOpen, setOpenState] = useState(false);
  const toggleOpenState = () => {
    setOpenState(!isOpen);
    if (updateNumOpen) updateNumOpen(isOpen ? -1 : 1);
    if (!isOpen) {
      AnalyticsTracking.trackEvent("faq_expanding_question_clicked", {
        question,
        location: ANALYTICS_LOCATION,
      });
    }
  };

  return (
    <Card p={0} mb={isOpen ? 2 : 0} className={bem()}>
      <CardSection className={bem("QuestionContainer")} onClick={toggleOpenState}>
        <Div className="flex-col-11" p={0}>
          <BodyText>{question}</BodyText>
        </Div>
        <Div className={classnames("flex-col-1", bem("ToggleIconContainer"))}>
          <Icon icon={isOpen ? "angle-up" : "angle-down"} />
        </Div>
      </CardSection>
      <Collapse in={isOpen} mountOnEnter>
        {/* This wrapping div is required for collapse to be smooth */}
        <div>
          <CardSection className={bem("AnswerContainer")}>{answer}</CardSection>
        </div>
      </Collapse>
    </Card>
  );
};
